module.exports = __webpack_public_path__ + "static/media/download.7eec6d1e.svg";